export default "__VITE_ASSET__CSPiPKOl__"